import http from "../../http";

export const umlReChat = (params: {
  thread_id: string;
  chart: string;
  errorMsg: string;
}) => {
  return http.post(`/api/v1/chat/uml`, {
    thread_id: params.thread_id,
    content: params.chart + "### " + params.errorMsg,
  });
};

export const wikiUmlReChat = (params: {
  title: string;
  chart: string;
  errorMsg: string;
}) => {
  return http.post(`/api/v1/wiki/uml`, {
    title: params.title,
    uml: params.chart + "### " + params.errorMsg,
  });
};

export const changeHistory = (params: {
  history_id: string;
  text: string;
  is_effective?: 0 | 1 | 2;
}) => {
  return http.put(`/api/v1/chat/chat_history`, {
    history_id: params.history_id,
    text: params.text,
    is_effective: params.is_effective
  });
};

export const changeWikiHistory = (params: {
  wiki_id: string;
  title: string;
  content: string;
}) => {
  return http.post(`/api/v1/wiki/page/update`, params);
};